var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.49 10.385l1.51 1.55v.757H0v-.757l1.51-1.55V6.562c0-2.38 1.227-4.327 3.368-4.867v-.541C4.878.504 5.368 0 6 0c.632 0 1.123.505 1.123 1.154v.54c2.14.541 3.369 2.524 3.369 4.868v3.823h-.001zM6 15a1.51 1.51 0 01-1.51-1.515h3.018c0 .83-.702 1.515-1.51 1.515H6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.51b9d78192c741350d10f735ebc6d070.svg";
export { ForwardRef as ReactComponent };